import React from "react";
import { Link } from "react-router-dom";
import { resolveMainSkinComponent } from "../../../../skins";
import "./skins.css";

function parseCustomLayoutCode(code = "") {
  return code
    .split("/")
    .map((row) => row.trim())
    .filter(Boolean)
    .map((row) => row.split(":")
      .map((part) => Math.max(1, Math.min(Number.parseInt(part.trim(), 10) || 1, 12)))
      .filter(Boolean))
    .filter(Boolean);
}

function layoutCapacity(preset, columns, rows) {
  if (preset === "custom") {
    return 0;
  }
  const base = columns * rows;
  if (preset === "top_focus") {
    return 1 + (columns * Math.max(rows - 1, 0));
  }
  if (preset === "masonry") {
    return base + rows;
  }
  return base;
}

function renderSlotContent(slot) {
  if (!slot) return null;
  if (slot.content_type === "device" && slot.device && slot.item) {
    const SelectedMainSkin = resolveMainSkinComponent(slot.skin);
    return <SelectedMainSkin card={slot} />;
  }
  if (slot.content_type === "image" && slot.image?.url) {
    const image = <img src={slot.image.url} alt={slot.image.alt || slot.label || "메인 이미지"} />;
    const linkUrl = slot.image.link_url || "";
    return (
      <div className="main-layout-basic__image-slot">
        {linkUrl ? (
          linkUrl.startsWith("http") ? <a href={linkUrl}>{image}</a> : <Link to={linkUrl}>{image}</Link>
        ) : image}
      </div>
    );
  }
  if (slot.content_type === "text" && (slot.text?.title || slot.text?.body)) {
    return (
      <article className="main-layout-basic__text-slot">
        {slot.text.title ? <strong>{slot.text.title}</strong> : null}
        {slot.text.body ? <p>{slot.text.body}</p> : null}
      </article>
    );
  }
  return <div className="main-layout-basic__unused-slot">미사용 슬롯</div>;
}

export default function BasicMainLayoutSkin({ cards = [], slots = [], layout = {}, error = "", links = [] }) {
  const preset = layout?.preset || "grid";
  const columns = Math.max(1, Math.min(Number(layout?.columns) || 2, 4));
  const rows = Math.max(1, Math.min(Number(layout?.rows) || 2, 6));
  const deviceCount = Math.max(1, Math.min(Number(layout?.device_count) || (columns * rows), 24));
  const customLayout = parseCustomLayoutCode(layout?.custom_code || "");
  const fallbackSlots = cards.map((card, index) => ({
    ...card,
    slot_index: index + 1,
    content_type: "device",
    label: `${index + 1}번 카드`,
  }));
  const sourceSlots = slots.length ? slots : fallbackSlots;
  const visibleSlots = sourceSlots.slice(
    0,
    Math.min(
      preset === "custom" ? customLayout.flat().length : layoutCapacity(preset, columns, rows),
      deviceCount,
    ),
  );

  return (
    <div className="main-layout-basic">
      {error ? <div className="main-layout-basic__error">{error}</div> : null}

      {/* <section className="main-layout-basic__hero">

        {links.length ? (
          <div className="main-layout-basic__quick-links">
            {links.map((link) => (
              <Link key={link.to} to={link.to}>
                {link.label}
              </Link>
            ))}
          </div>
        ) : null}
      </section> */}

      {!sourceSlots.length ? (
        <section className="main-layout-basic__panel">
          <div className="main-layout-basic__empty">
            메인 노출로 지정된 디바이스 카드가 없습니다.
          </div>
        </section>
      ) : preset === "custom" && customLayout.length ? (
        <section className="main-layout-basic__custom-layout">
          {(() => {
            let cardIndex = 0;
            return customLayout.map((row, rowIndex) => {
              const rowSlots = visibleSlots.slice(cardIndex, cardIndex + row.length);
              cardIndex += row.length;
              return (
                <div
                  key={`custom-row:${rowIndex}`}
                  className="main-layout-basic__custom-row"
                  style={{ gridTemplateColumns: row.map((value) => `${value}fr`).join(" ") }}
                >
                  {rowSlots.map((slot) => (
                    <div key={`slot:${slot.slot_index}`}>
                      {renderSlotContent(slot)}
                    </div>
                  ))}
                </div>
              );
            });
          })()}
        </section>
      ) : preset === "top_focus" ? (
        <section className="main-layout-basic__top-focus-layout">
          {visibleSlots[0] ? (
            <div className="main-layout-basic__top-focus-lead">
              {renderSlotContent(visibleSlots[0])}
            </div>
          ) : null}
          {(() => {
            const rows = [];
            for (let startIndex = 1; startIndex < visibleSlots.length; startIndex += columns) {
              rows.push(visibleSlots.slice(startIndex, startIndex + columns));
            }
            return rows.map((rowSlots, rowIndex) => (
              <div
                key={`top-focus-row:${rowIndex}`}
                className="main-layout-basic__top-focus-row"
                style={{ gridTemplateColumns: `repeat(${rowSlots.length}, minmax(0, 1fr))` }}
              >
                {rowSlots.map((slot) => (
                  <div key={`slot:${slot.slot_index}`}>
                    {renderSlotContent(slot)}
                  </div>
                ))}
              </div>
            ));
          })()}
        </section>
      ) : (
        <section
          className={`main-layout-basic__card-grid main-layout-basic__card-grid--${preset}`}
          style={{ "--main-grid-cols": columns }}
        >
          {visibleSlots.map((slot) => (
            <div key={`slot:${slot.slot_index}`}>
              {renderSlotContent(slot)}
            </div>
          ))}
        </section>
      )}
    </div>
  );
}
